import axios from 'axios'
import store from '../../store'
// Define base url
const BASE_URL = '/api/v1/attendances'

// Define attendances module
const attendances = {
  state: {
    data: {},
    errors: {}
  },
  getters: {
    attendancesCollection: state => {
      return state.data
    }
  },
  mutations: {
    getAttendancesData (state, payload) {
      state.data = payload
    },
    setAttendancesErrors (state, payload) {
      state.errors = payload
    },
    deleteAttendanceData (state, payload) {
      const index = state.data.findIndex(i => i.id === payload)
      state.data.splice(index, 1)
    }
  },
  actions: {
    async attendancesGetData ({ commit }, payload) {
      try {
        const response = await axios.get(`${BASE_URL}/${payload}`, payload)
        if (response.status === 200) {
          commit('getAttendancesData', response.data.data)
        }
      } catch (error) {
        commit('setAttendancesErrors', error)
      }
    },
    async attendancesStore ({ commit }, payload) {
      try {
        const response = await axios.post(BASE_URL, payload)
        if (response.status === 201) {
          return response.data.data
        }
      } catch (error) {
        commit('setAttendancesErrors', error.response.data.errors)
      }
    },
    async attendancesUpdate ({ commit }, payload) {
      try {
        const response = await axios.put(`${BASE_URL}/${payload.id}`, payload)
        if (response.status === 202) {
          return response.data.data
        }
      } catch (error) {
        commit('setAttendancesErrors', error.response.data.errors)
      }
    },
    async attendancesDestroy ({ commit }, payload) {
      try {
        const response = await axios.delete(`${BASE_URL}/${payload}`, payload)
        if (response.status === 204) {
          commit('deleteAttendanceData', payload)
        }
      } catch (error) {
        commit('setAttendancesErrors', error)
      }
    },
    async attendancesApproval ({ commit }, payload) {
      try {
        const response = await axios.put(`${BASE_URL}/${payload.id}/approval`, payload)
        if (response.status === 202) {
          return response.data.data
        }
      } catch (error) {
        commit('setAttendancesErrors', error)
      }
    }
  }
}

// Export the attendances module
export default attendances
